module.exports = __webpack_public_path__ + "img/f21.5cde0eb9.jpg";